import Papa from 'papaparse';

/**
 * Parses a CSV text body into an array of loosely-typed row records.
 * Every value comes back as a string; adapters are responsible for
 * numeric coercion (see utils/numbers.ts) since source files are not
 * trusted to always be well-formed.
 */
export function parseCsv(text: string): Record<string, string>[] {
  const result = Papa.parse<Record<string, string>>(text, {
    header: true,
    skipEmptyLines: true,
    transformHeader: (h) => h.trim(),
  });
  if (result.errors?.length) {
    // Papa reports row-level parse issues (e.g. inconsistent column count).
    // We surface these as warnings via the caller rather than throwing --
    // a single malformed row should not take down the whole source.
    console.warn('[csv] parse warnings', result.errors.slice(0, 5));
  }
  return result.data.filter((row) => Object.keys(row).length > 0);
}

export async function fetchCsv(url: string, signal?: AbortSignal): Promise<string> {
  const res = await fetch(url, { signal });
  if (!res.ok) {
    throw new Error(`fetchCsv: ${url} responded ${res.status}`);
  }
  return res.text();
}
